var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "table-wrapper" }, [
    _c("table", { staticClass: "data-table text-sm w-full font-outfit" }, [
      _c("thead", [
        _c(
          "tr",
          [
            _vm.showCheckboxes
              ? _c(
                  "th",
                  {
                    staticClass:
                      "bg-lightBlue px-2 py-2 border-b-1 border-gray-200 text-left font-medium",
                  },
                  [
                    _c("label", { staticClass: "custom-checkbox" }, [
                      _c("input", {
                        attrs: { type: "checkbox" },
                        domProps: { checked: _vm.areAllApprovedSelected },
                        on: { change: _vm.handleHeaderCheckboxChange },
                      }),
                      _c("span", { staticClass: "icon-checked" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "11",
                              height: "9",
                              viewBox: "0 0 11 9",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                              margin: "0",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M1.91308 4.03516H1.91326C1.99256 4.03525 2.07081 4.05331 2.14213 4.08798C2.21341 4.12262 2.27591 4.17295 2.32497 4.2352L1.91308 4.03516ZM1.91308 4.03516H1.09394C0.890308 4.03516 0.776602 4.26975 0.902321 4.4292L0.902371 4.42927L4.11214 8.49567L4.11218 8.49573C4.32247 8.76188 4.72568 8.76114 4.93667 8.49617L4.93708 8.49566L10.6597 1.24398C10.6598 1.24378 10.66 1.24358 10.6602 1.24338C10.7884 1.08295 10.6699 0.85 10.4689 0.85H9.6498C9.48941 0.85 9.33668 0.9235 9.2376 1.05044C9.23751 1.05055 9.23742 1.05066 9.23734 1.05077L4.52403 7.02157M1.91308 4.03516L4.52403 7.02157M4.52403 7.02157L2.32506 4.23531L4.52403 7.02157Z",
                                fill: "white",
                                stroke: "white",
                                "stroke-width": "0.3",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._l(_vm.headers, function (header) {
              return _c(
                "th",
                {
                  key: header.text,
                  staticClass:
                    "bg-lightBlue px-2 py-2 border-b-1 border-gray-200 text-left font-medium",
                },
                [
                  _c("div", { staticClass: "flex items-center gap-2" }, [
                    _vm._v(" " + _vm._s(header.text) + " "),
                    header.sort
                      ? _c("span", { staticClass: "ml-auto" }, [
                          header.icon
                            ? _c(
                                "span",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.sortColumn(header.value)
                                    },
                                  },
                                },
                                [_c(header.icon, { tag: "component" })],
                                1
                              )
                            : _c(
                                "span",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.sortColumn(header.value)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "8",
                                        height: "12",
                                        viewBox: "0 0 8 12",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M7.94188 4.57036L4.21022 0.0960542C4.1034 -0.0320181 3.89773 -0.0320181 3.78978 0.0960542L0.0581151 4.57036C-0.0805157 4.7372 0.0444792 4.9816 0.268334 4.9816H7.73167C7.95552 4.9816 8.08052 4.7372 7.94188 4.57036Z",
                                          fill:
                                            _vm.sort_by === header.value &&
                                            _vm.sort_direction === "asc"
                                              ? "none"
                                              : "black",
                                          "fill-opacity": "0.25",
                                          stroke:
                                            _vm.sort_by === header.value &&
                                            _vm.sort_direction === "asc"
                                              ? "black"
                                              : "none",
                                          "stroke-width": "0.2",
                                          "stroke-opacity": "0.25",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d: "M7.73167 7.0184H0.268334C0.0444792 7.0184 -0.0805157 7.2628 0.0581151 7.42964L3.78978 11.9039C3.89659 12.032 4.10227 12.032 4.21022 11.9039L7.94188 7.42964C8.08052 7.2628 7.95552 7.0184 7.73167 7.0184Z",
                                          fill:
                                            _vm.sort_by === header.value &&
                                            _vm.sort_direction === "desc"
                                              ? "none"
                                              : "black",
                                          "fill-opacity": "0.25",
                                          stroke:
                                            _vm.sort_by === header.value &&
                                            _vm.sort_direction === "desc"
                                              ? "black"
                                              : "none",
                                          "stroke-width": "0.2",
                                          "stroke-opacity": "0.25",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                        ])
                      : _vm._e(),
                    _c(
                      "span",
                      [
                        header.value === "total_amount"
                          ? _c(
                              "Tooltip",
                              {
                                staticClass: "flex items-center ml-2",
                                attrs: {
                                  variant: _vm.TooltipVariants.DARK,
                                  title: "Total invoice amount before tax.",
                                  tooltipClasses: "w-56",
                                  placement: "bottom",
                                },
                              },
                              [
                                header.value === "total_amount"
                                  ? _c("TableInfo")
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]
              )
            }),
          ],
          2
        ),
      ]),
      _c(
        "tbody",
        [
          _vm._l(_vm.data, function (item, index) {
            return _c(
              "tr",
              {
                key: index,
                staticClass: "message-unread",
                class:
                  _vm.showCheckboxes &&
                  !_vm.canShowCheckbox(item) &&
                  "tr-disabled",
              },
              [
                _vm.showCheckboxes
                  ? _c(
                      "td",
                      {
                        staticClass:
                          "px-2 py-2 border-b-1 border-gray-200 font-normal",
                      },
                      [
                        _c("label", { staticClass: "custom-checkbox" }, [
                          _vm.canShowCheckbox(item)
                            ? _c("input", {
                                attrs: { type: "checkbox" },
                                domProps: { checked: _vm.isSelected(item) },
                                on: {
                                  change: function ($event) {
                                    return _vm.handleRowCheckboxChange(item)
                                  },
                                },
                              })
                            : _vm._e(),
                          _c("span", { staticClass: "icon-checked" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "11",
                                  height: "9",
                                  viewBox: "0 0 11 9",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M1.91308 4.03516H1.91326C1.99256 4.03525 2.07081 4.05331 2.14213 4.08798C2.21341 4.12262 2.27591 4.17295 2.32497 4.2352L1.91308 4.03516ZM1.91308 4.03516H1.09394C0.890308 4.03516 0.776602 4.26975 0.902321 4.4292L0.902371 4.42927L4.11214 8.49567L4.11218 8.49573C4.32247 8.76188 4.72568 8.76114 4.93667 8.49617L4.93708 8.49566L10.6597 1.24398C10.6598 1.24378 10.66 1.24358 10.6602 1.24338C10.7884 1.08295 10.6699 0.85 10.4689 0.85H9.6498C9.48941 0.85 9.33668 0.9235 9.2376 1.05044C9.23751 1.05055 9.23742 1.05066 9.23734 1.05077L4.52403 7.02157M1.91308 4.03516L4.52403 7.02157M4.52403 7.02157L2.32506 4.23531L4.52403 7.02157Z",
                                    fill: "white",
                                    stroke: "white",
                                    "stroke-width": "0.3",
                                  },
                                }),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._l(_vm.headers, function (header) {
                  return _c(
                    "td",
                    {
                      key: header.value,
                      staticClass: "px-2 py-2 border-b-1 border-gray-200",
                    },
                    [
                      header?.isLink && item.file
                        ? _c(
                            "span",
                            {
                              staticClass: "link-holder",
                              on: {
                                click: function ($event) {
                                  return _vm.handleDropdownAction(
                                    "externalLink",
                                    item
                                  )
                                },
                              },
                            },
                            [_vm._v(_vm._s(item[header.value]))]
                          )
                        : header?.isLink && !item.file
                        ? _c(
                            "a",
                            {
                              staticClass: "link-holder",
                              attrs: {
                                href: item[header.value],
                                target: "_blank",
                              },
                            },
                            [_vm._v(_vm._s(item[header.value]))]
                          )
                        : header?.badge
                        ? _c(
                            "span",
                            {
                              staticClass: "status",
                              class: item[header.value],
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.status(item[header.value])) +
                                  " "
                              ),
                              item[header.value] === "PAYMENT SEND"
                                ? _c(
                                    "Tooltip",
                                    {
                                      staticClass: "flex items-center ml-2",
                                      attrs: {
                                        variant: _vm.TooltipVariants.DARK,
                                        title:
                                          "Payment is being processed at the bank. The funds may not be available yet at this time. ",
                                        tooltipClasses: "w-56",
                                        placement: "bottom",
                                      },
                                    },
                                    [
                                      item[header.value] === "PAYMENT SEND"
                                        ? _c("BadgeInfoIcon")
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : header?.action
                        ? _c(
                            "div",
                            { staticClass: "actions flex items-center" },
                            _vm._l(_vm.actions, function (action) {
                              return _c(
                                "span",
                                {
                                  key: action.name,
                                  staticClass:
                                    "action-button mx-2.5 w-6 h-6 flex items-center justify-center cursor-pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.emitAction(action.name, item)
                                    },
                                  },
                                },
                                [
                                  _c(action.icon, { tag: "component" }),
                                  _vm.openDropdown === item.id &&
                                  action.name === "action"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "absolute action-button-dropdown bg-white",
                                        },
                                        [
                                          _c(
                                            "ul",
                                            {
                                              staticClass:
                                                "action-button__list",
                                            },
                                            [
                                              _c(
                                                "li",
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleDropdownAction(
                                                        "sendByEmail",
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " Send invoice by email "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "li",
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleDropdownAction(
                                                        "notifyManager",
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" Notify Admin ")]
                                              ),
                                              item.status === "PENDING"
                                                ? _c(
                                                    "li",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleDropdownAction(
                                                            "cancelInvoice",
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" Cancel invoice ")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : header.value === "reference_number"
                        ? _c("div", { staticClass: "ref_id" }, [
                            _vm._v(" " + _vm._s(item[header.value]) + " "),
                          ])
                        : header.value === "notes"
                        ? _c(
                            "button",
                            {
                              staticClass: "notes",
                              on: {
                                click: function ($event) {
                                  return _vm.showNotes(item)
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M6 6.125C6 4.95293 6.95293 4 8.125 4H13.4375V8.25C13.4375 8.8377 13.9123 9.3125 14.5 9.3125H18.75V18.875C18.75 20.0471 17.7971 21 16.625 21H8.125C6.95293 21 6 20.0471 6 18.875V6.125ZM18.75 8.25H14.5V4L18.75 8.25Z",
                                      fill: "#010A11",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : header.value === "rate"
                        ? _c("span", [_vm._v("$" + _vm._s(item[header.value]))])
                        : [_vm._v(" " + _vm._s(item[header.value]) + " ")],
                    ],
                    2
                  )
                }),
              ],
              2
            )
          }),
          _vm.data.length === 0 ? _c("tr", [_vm._m(0)]) : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", { staticClass: "empty-state", attrs: { colspan: "9" } }, [
      _c("div", { staticClass: "empty-state-text" }, [
        _vm._v("No data to show"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }